<template>
    <div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="采购单列表" name="1">
                <buyList/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import buyList from './components/buyList.vue';
export default {
   data() {
      return {
        activeName: "1"
      }
   },
   created(){
    
   },
   components:{
        buyList,
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="scss" scoped>

</style>
